<template>
	<a-modal
		title="新增用户"
		:width="520"
		:visible="visible"
		:confirmLoading="loading"
		:maskClosable="false"
		@ok="() => { $emit('ok') }"
		@cancel="() => { $emit('cancel') }"
	>
		<a-form-model ref="userForm" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
			<a-form-model-item label="角色" prop="roleId"
				:rules="[{ required: true, message: '请选择角色', trigger: 'change' }]">
				<a-select
					v-model="form.roleId"
					placeholder="请选择角色"
				>
					<a-select-option
						v-for="role in roleList"
						:key="role.id"
						:value="role.id"
					>{{ role.name }}</a-select-option>
				</a-select>
			</a-form-model-item>
            <a-form-model-item label="昵称" prop="nickname"
                :rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]"
            >
                <a-input v-model="form.nickname" />
            </a-form-model-item>
			<a-form-model-item label="账号" prop="loginAccount"
				:rules="[
					{ required: true, message: '必填，不能为空', trigger: 'blur' },
					{ validator: isExistLoginAccount, trigger: 'blur' },
				]">
				<a-input v-model="form.loginAccount" />
			</a-form-model-item>
			<a-form-model-item label="密码" prop="loginPassword"
				:rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
				<a-input v-model="form.loginPassword" />
			</a-form-model-item>
			<a-form-model-item label="备注" prop="remark">
				<a-input v-model="form.remark" />
			</a-form-model-item>
		</a-form-model>
	</a-modal>
</template>

<script>
import { userLoginAccountIsExist, userRoleList } from '@/api/member/user';

export default {
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			form: {
                loginAccount: '',
                loginPassword: '',
                nickname: '',
                remark: '',
            },
			roleList: [],
		};
	},
    created() {
        this.fetchRoleOptions();
    },
    methods: {
		fetchRoleOptions() {
			return userRoleList().then((res) => {
				this.roleList = res.data.roleList || [];
			});
		},
		isExistLoginAccount(rule, value, callback) {
			if (!value) {
				callback();
				return;
			}
			userLoginAccountIsExist(value).then((res) => {
				if (res.data) {
					callback(new Error('账号已存在'));
				} else {
					callback();
				}
			}).catch(() => callback());
		},
	},
};
</script>
